var STORAGE_KEY = 'usuario';

function getUserData() {
  try {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

function buildUserDataLayer() {
  var user = getUserData();
  if (!user) return {};

  var names = (user.nome_usuario || '').split(' ');
  var firstName = names[0] || '';
  var lastName = names.length > 1 ? names.slice(1).join(' ') : '';

  var rawPhone = user.nr_celular || user.nr_fone || '';
  var cleanPhone = rawPhone.replace(/\D/g, '');
  var formattedPhone = cleanPhone ? '+55' + cleanPhone : '';

  return {
    user_id: String(user.pk_usuario),
    user_data: {
      email_address: user.email_usuario || '',
      phone_number: formattedPhone,
      address: {
        first_name: firstName,
        last_name: lastName,
      },
    },
  };
}

module.exports = {
  getUserData: getUserData,
  buildUserDataLayer: buildUserDataLayer,
};